export default {
  strict: true,
  namespaced: true,
  state: {
    isLoading: false,
    loadingMessage: 'Loading',
  },
  mutations: {
    startLoad(state, message) {
      state.isLoading = true;
      if (message) state.loadingMessage = message;
    },
    finishLoad(state) {
      state.isLoading = false;
      state.loadingMessage = 'Loading';
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/views/dialog.js